
import { ProjectViewMixin } from '@/mixins/ProjectViewMixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'project-content-restaurant',
})
export default class ProjectContentRestaurant extends mixins(ProjectViewMixin) {}
